import { QuickFilterBar as FilterBar } from "components/form_components/QuickFilterBar";
import { EventDataTypes } from "lib/tracking";
import { SortState } from "../../lib/search/types";
import { getBuyersColumnCopy } from "./utils/getBuyersColumnCopy";
import { BuyerTableFilters } from "./utils/types";
import { BuyerFilterSections } from "./BuyerFilterForm";
import { TableData } from "./types";

function getAppliedFilters(filters: BuyerTableFilters): (keyof BuyerTableFilters)[] {
  const appliedFiltersArray = Object.entries(filters).filter(([_key, value]) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === "object") {
      return Object.keys(value).length > 0;
    }
    if (typeof value === "string") {
      return value.length > 0;
    }
    if (typeof value === "boolean") {
      return true;
    }
    return false;
  });

  return appliedFiltersArray.map(([key]) => key as keyof BuyerTableFilters);
}

const sectionToFilterKey: Record<BuyerFilterSections, (keyof BuyerTableFilters)[]> = {
  suppliers: ["supplierGuids", "supplierSme"],
  buyerInformation: ["buyerName", "buyerGuids", "buyerTypes"],
  buyerSearch: [],
  buyerLists: ["buyerLists"],
  signals: [],
};

export function QuickFilterBar({
  filters,
  sortState,
  onClearFilter,
  onFilterClick,
  hiddenSections,
  tableData,
  clearAllFilters,
  clearAllFiltersHide,
}: {
  filters: BuyerTableFilters;
  sortState: SortState;
  onClearFilter: (value: keyof BuyerTableFilters) => void;
  onFilterClick: (value: keyof BuyerTableFilters) => void;
  hiddenSections: BuyerFilterSections[];
  // TODO: Fetch this from react context using a hook
  tableData: TableData;
  clearAllFilters: () => void;
  clearAllFiltersHide?: () => boolean;
}) {
  const hiddenSectionFields =
    hiddenSections?.map((section) => sectionToFilterKey[section]).flat() || [];

  const appliedFiltersMapped = getAppliedFilters(filters);

  const filterKeyToLabel: Record<keyof BuyerTableFilters, string> = {
    buyerName: "Buyer name",
    countryCodes: "Country",
    hqCountry: "Buyer HQ",
    supplierGuids: `Suppliers ${filters.supplierGuids?.length}`,
    supplierSme: "SME Supplier",
    buyerTypes: "Buyer Type",
    buyerGuids: `Buyers (${filters.buyerGuids?.length})`,
    buyerLists: `Buyer lists (${filters.buyerLists?.length})`,
    regionIds: "Region IDs",
  };

  const {
    totalCount,
    queryResult: { isLoading },
  } = tableData;

  return (
    <FilterBar<BuyerTableFilters>
      appliedFilters={appliedFiltersMapped}
      isLoading={isLoading}
      totalResults={totalCount || 0}
      filterKeyToLabel={filterKeyToLabel}
      onClear={onClearFilter}
      onFilterClick={onFilterClick}
      sortField={getBuyersColumnCopy(sortState.field)}
      dataType={EventDataTypes.buyer}
      hiddenFields={hiddenSectionFields}
      clearAllFilters={clearAllFilters}
      clearAllFiltersHide={clearAllFiltersHide}
    />
  );
}
